import { useDispatch } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAppSelector } from "../../redux-store/CustomReduxHooks";
import { useLazyFetchPolicyInsuredQuery } from "./HealthInsurance_Api";
import { useEffect, useState } from "react";
import { setHiAllPolicyInsuredDetails } from "./HealthInsurance_Slice";
import { T_HiRouteState } from "../../globalTypes/GlobalTypes";
import NotFound from "../../pages/NotFound/NotFound";
import { updateLoadingState } from "../Feature_Loading/Loading_Slice";
import { isEmpty } from "lodash";
import { API_STATUS_CODE } from "../../utils/ApiEndpoints";
import { UseHiBaseDataLoader } from "./HiBaseDataInit/Hi_Init_BaseData";
import CustomPolicyOrAccountSelect from "../../components/CustomPolicyOrAccountSelect/CustomPolicyOrAccountSelect";
import { HiLobCode } from "../../utils/constants";

const HiDocumentGuard = () => {
  const { state, pathname, search } = useLocation();
  // const [isResponseEmpty, setIsResponseEmpty] = useState(false);
  const policyNumber = (state as T_HiRouteState)?.policyNumber || "";
  const { isFetching, error } = UseHiBaseDataLoader("primary", policyNumber);
  console.log(policyNumber);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const [fetchPolicyInsuredApi, { isError, error }] =
  //   useLazyFetchPolicyInsuredQuery();
  const hiPrimaryAllPolicyDetails = useAppSelector(
    (state) => state.HealthInsuranceSlice.allPolicyDetails
  );

  useEffect(() => {
    if (isFetching) {
      dispatch(updateLoadingState(true));
    } else {
      dispatch(updateLoadingState(false));
    }
  }, [isFetching]);

  useEffect(() => {
    console.log(isFetching, error);
  }, [isFetching, error]);

  // useEffect(() => {
  //   if (isEmpty(policyInsuredDetails)) {
  //     dispatch(updateLoadingState(true));
  //     fetchPolicyInsuredApi(policyNumber, true).then((res) => {
  //       dispatch(updateLoadingState(false));
  //       if (res.data?.code === API_STATUS_CODE.SUCCESS) {
  //         if (isEmpty(res?.data?.payload?.Response)) {
  //           setIsResponseEmpty(true);
  //         } else {
  //           dispatch(
  //             setHiAllPolicyInsuredDetails([res?.data?.payload?.Response])
  //           );
  //         }
  //       } else {
  //         setIsResponseEmpty(true);
  //       }
  //     });
  //   }
  // }, [policyInsuredDetails]);

  const onPolicyNumberSelection = (policyNumber: string) => {
    navigate(pathname + search, { replace: true, state: { policyNumber } });
  };

  if (!policyNumber && !isEmpty(hiPrimaryAllPolicyDetails)) {
    return (
      <CustomPolicyOrAccountSelect
        data={{
          isOpen: true,
          options: hiPrimaryAllPolicyDetails.map((item) => item.PolicyNumber),
          lobDetails: {
            lobId: HiLobCode,
            lobName: "",
            lob: "",
            uniqueId: true,
          },
          redirectionUrl: "",
        }}
        policyOrAccountDataHandler={onPolicyNumberSelection}
        // setIsPolicySelectionOpen={setIsPolicySelectionOpen}
        fromGuard={true}
      />
    );
  }

  return error ? (
    <NotFound
      moduleName="HI"
      pageName="HiDocumentGuard"
      errorTitle=""
      errorMessage={error}
    />
  ) : isFetching || isEmpty(policyNumber) ? (
    <></>
  ) : (
    <Outlet />
  );
};

export default HiDocumentGuard;
